module.exports = __webpack_public_path__ + "static/media/medienboard.6faf13ed.png";